module.exports = __webpack_public_path__ + "img/arrows-helper.da1df1f3.gif";